var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "SearchPanel",
        {
          attrs: { flex: "", "show-btn": "", size: "mini" },
          on: { getList: _setup.onSearch },
        },
        [
          _setup.isMemberStore
            ? _c(
                "div",
                [
                  _c("p", [_vm._v(" 供应商ID: ")]),
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入供应商ID",
                      size: "mini",
                      type: "number",
                      clearable: "",
                    },
                    model: {
                      value: _setup.searchData.supplierID,
                      callback: function ($$v) {
                        _vm.$set(
                          _setup.searchData,
                          "supplierID",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchData.supplierID",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _setup.isMemberStore
            ? _c(
                "div",
                [
                  _c("p", [_vm._v(" 供应商名称: ")]),
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入供应商名称",
                      size: "mini",
                      clearable: "",
                    },
                    model: {
                      value: _setup.searchData.supplierName,
                      callback: function ($$v) {
                        _vm.$set(
                          _setup.searchData,
                          "supplierName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchData.supplierName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c("p", [_vm._v(" 对账单名称: ")]),
              _c("el-input", {
                attrs: {
                  placeholder: "请输入对账单名称",
                  size: "mini",
                  clearable: "",
                },
                model: {
                  value: _setup.searchData.orderNo,
                  callback: function ($$v) {
                    _vm.$set(
                      _setup.searchData,
                      "orderNo",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchData.orderNo",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v(" 销售渠道: ")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "请选择状态",
                    filterable: "",
                    clearable: "",
                  },
                  on: {
                    change: function ($event) {
                      return _setup.getSearchList()
                    },
                  },
                  model: {
                    value: _setup.searchData.channelType,
                    callback: function ($$v) {
                      _vm.$set(_setup.searchData, "channelType", $$v)
                    },
                    expression: "searchData.channelType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "本平台", value: "1" } }),
                  _c("el-option", { attrs: { label: "沪上公社", value: "2" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v(" 状态 ")]),
              _c(
                "el-select",
                {
                  attrs: {
                    size: "mini",
                    placeholder: "请选择状态",
                    filterable: "",
                    clearable: "",
                  },
                  on: {
                    change: function ($event) {
                      return _setup.getSearchList()
                    },
                  },
                  model: {
                    value: _setup.searchData.type,
                    callback: function ($$v) {
                      _vm.$set(_setup.searchData, "type", $$v)
                    },
                    expression: "searchData.type",
                  },
                },
                _vm._l(_setup.typeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value + "type",
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v(" 创建时间 ")]),
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  size: "mini",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "timestamp",
                },
                model: {
                  value: _setup.dateRange,
                  callback: function ($$v) {
                    _setup.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: { click: _setup.resetSearch },
              slot: "button-right",
            },
            [_vm._v(" 重 置 ")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                slot: "button-right",
                type: "primary",
                size: "mini",
                loading: _setup.downLoading,
              },
              on: { click: _setup.download },
              slot: "button-right",
            },
            [_vm._v(" 导 出 ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.loading,
              expression: "loading",
            },
          ],
          staticClass: "tableBox",
          attrs: {
            data: _setup.tableData,
            "cell-style": {
              background: "#FAFAFA",
            },
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "对账单名称", "min-width": "230" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.settlementInterval))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "销售渠道", "min-width": "230" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.channelTypeName))])]
                },
              },
            ]),
          }),
          _setup.isMemberStore
            ? _c("el-table-column", {
                attrs: { label: "供应商ID", "min-width": "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_c("span", [_vm._v(_vm._s(row.supplierId))])]
                      },
                    },
                  ],
                  null,
                  false,
                  334428125
                ),
              })
            : _vm._e(),
          _setup.isMemberStore
            ? _c("el-table-column", {
                attrs: { label: "供应商" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_c("span", [_vm._v(_vm._s(row.supplierName))])]
                      },
                    },
                  ],
                  null,
                  false,
                  101953751
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "订货金额（元）", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.purchaseAmount))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订货退货金额（元）", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.refundAmount))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "实际订货金额（元）", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.actuallyAmount))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订货对账金额（元）", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.checkAmount))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_c("span", [_vm._v(_vm._s(row.auditStatusName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间", "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_setup.formatTime(row.createTime))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _setup.handleDetail(row, "detail")
                          },
                        },
                      },
                      [_vm._v(" 查看 ")]
                    ),
                    _setup.isMemberStore &&
                    (row.auditStatus === 0 || row.auditStatus === -1)
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _setup.handleDetail(row, "edit")
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        )
                      : _vm._e(),
                    _setup.isMemberStore && row.auditStatus === 0
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _setup.submit(row)
                              },
                            },
                          },
                          [_vm._v(" 提交 ")]
                        )
                      : _vm._e(),
                    row.auditStatus === 1 && !_setup.isMemberStore
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _setup.handleDetail(row, "edit")
                              },
                            },
                          },
                          [_vm._v(" 审核 ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _setup.exportData(row)
                          },
                        },
                      },
                      [_vm._v(" 导出 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _setup.currentPage,
          "page-sizes": [10, 20, 30, 50],
          "page-size": _setup.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _setup.count,
        },
        on: {
          "size-change": _setup.handleSizeChange,
          "current-change": _setup.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订货退货审核",
            visible: _setup.dialogFormVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _setup.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _setup.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核结果" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.form.state,
                        callback: function ($$v) {
                          _vm.$set(_setup.form, "state", $$v)
                        },
                        expression: "form.state",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(" 同意 "),
                      ]),
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v(" 拒绝 "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "原因说明" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "50",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _setup.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _setup.examineClose } }, [
                _vm._v(" 取 消 "),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _setup.examineConfirm },
                },
                [_vm._v(" 确 定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }